// extracted by mini-css-extract-plugin
module.exports = {"terms__header":"Terms_terms__header__1GFkG","terms__header__wrapper":"Terms_terms__header__wrapper__2cIeV","terms__body":"Terms_terms__body__2SFKF"};